<template>
  <div class="ly_modal_container" :style="{width: '970px', zIndex}">
    <div class="ly_modal_header" @mousedown="dragStart">
      <h1 class="title">받는사람</h1>
    </div>
    <div class="ly_modal_content" style="min-height:485px">
      <ScrollTable ref="table" :sourceList="tableItems">
        <template #header>
          <caption>
            <span class="blind">받는사람</span>
          </caption>
          <colgroup>
            <!-- <col width="50" /> -->
            <col width="120" />
            <col width="200" />
            <col width="250" />
            <!-- <col width="100" />
            <col width="100" /> -->
            <col width="100" />
          </colgroup>

          <thead class="table_list_head">
            <tr>
              <!-- <CheckAllHeader :selectedList="selectedList" :sourceList="selectableList" /> -->
              <th>이름</th>
              <th>TID</th>
              <th>그룹</th>
              <!-- <th>확인여부</th>
              <th>스피커알림</th> -->
              <th>상세</th>
            </tr>
          </thead>
        </template>
        <template #row="{ rowData }">
          <tr>
            <!-- <td>
              <input
                type="checkbox"
                :value="rowData"
                v-model="selectedList"
                :disabled="!rowData.resendButtonEnable"
              />
            </td> -->
            <td>{{rowData.rcpName}}</td>
            <td>{{rowData.rcpNuguTid}}</td>
            <td>{{rowData.rcpGroup}}</td>
            <!-- <ConfirmTextColumn :value="rowData.rcpReadYn" />
            <PushStatusColumn
              displayType="RCP"
              :statusCode="rowData.pushStatus"
            /> -->
            <td>
              <button
                v-if="detailLinkUrl(rowData)"
                type="button"
                class="btn_function"
                @click="$router.push(detailLinkUrl(rowData))"
              >보기</button>
              <span v-else>-</span>
            </td>
          </tr>
        </template>
      </ScrollTable>

      <div class="btn_area">
        <!-- <button type="button" class="btn_active" @click="resend">알림 재전송</button> -->
        <button type="button" class="btn_default" @click="close">닫기</button>
      </div>
    </div>

    <button type="button" @click.prevent="close" class="ly_modal_close">
      <span class="ico">팝업 닫기</span>
    </button>
  </div>
</template>

<script>
import GeneralRecipientList from "./GeneralRecipientList";

export default {
  extends: GeneralRecipientList,
  methods: {
    detailLinkUrl(rowData) {
      const url = `/news/recipient/${rowData.rcpId}/repeat`;
      return url != this.$route.path ? url : null;
    },
  }
};
</script>
